interface IErrorResponse {
	status?: number;
}

export const isAuthError = (response?: IErrorResponse | null): boolean => (
	response?.status === 401 || response?.status === 403
);
